var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("ModalFullScreen", {
        attrs: { title: _vm.title, withBgClickEvent: true },
        on: { close: _vm.handleCancel },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "bg-red" },
                    [
                      _c("FormTextarea", {
                        attrs: {
                          customBorderClass: "borderTen",
                          placeholder: "Edit notes here",
                          rows: 10,
                        },
                        model: {
                          value: _vm.editContractorNote,
                          callback: function ($$v) {
                            _vm.editContractorNote = $$v
                          },
                          expression: "editContractorNote",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "flex pt-3" },
                    [
                      _vm._t("actions", function () {
                        return [
                          _c("UIButton", {
                            attrs: {
                              buttonText: "Save",
                              variant: "black",
                              size: "lg",
                              processing: _vm.processing,
                            },
                            on: { click: _vm.onUpdate },
                          }),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }